// Tipos compartilhados entre página + modais de contas (portado do super.old).

export type ContaPlan = 'starter' | 'pro' | 'enterprise'
export type ContaStatus = 'active' | 'trial' | 'suspended' | 'cancelled'
export type EmpresaStatus = 'active' | 'suspended'

export interface Conta {
  id: string
  nome: string
  email: string
  telefone: string | null
  plan: ContaPlan
  status: ContaStatus
  total_empresas: number
  user_id: string | null
  created_at: string
}

export interface EmpresaDaConta {
  id: string
  nome: string
  slug: string
  cnpj: string | null
  razao_social: string | null
  api_key: string
  tracking_short_code: string
  status: EmpresaStatus
  created_at: string
}

export interface ContaDetalhe extends Omit<Conta, 'total_empresas'> {
  empresas: EmpresaDaConta[]
}

export interface ContaFormData {
  nome: string
  email: string
  telefone: string
  plan: ContaPlan
  status: ContaStatus
}

export interface EmpresaFormData {
  nome: string
  razao_social: string
  cnpj: string
}

export interface EmpresaEditFormData {
  nome: string
  razao_social: string
  cnpj: string
  status: EmpresaStatus
}

export const EMPTY_CONTA_FORM: ContaFormData = {
  nome: '',
  email: '',
  telefone: '',
  plan: 'starter',
  status: 'active',
}

export const EMPTY_EMPRESA_FORM: EmpresaFormData = {
  nome: '',
  razao_social: '',
  cnpj: '',
}

// ─── Helpers ────────────────────────────────────────────────────────────────

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}

export function maskCNPJ(value: string): string {
  const d = value.replace(/\D/g, '').slice(0, 14)
  if (d.length <= 2) return d
  if (d.length <= 5) return `${d.slice(0, 2)}.${d.slice(2)}`
  if (d.length <= 8) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`
  if (d.length <= 12) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`
}

export function formatCNPJ(cnpj: string): string {
  const onlyDigits = cnpj.replace(/\D/g, '')
  if (onlyDigits.length !== 14) return cnpj
  return cnpj
}
